var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.2684 229.149C99.885 244.221 112.507 256 128.007 256C143.508 256 156.114 244.219 157.737 229.149C147.845 229.897 137.928 230.276 128.007 230.286C121.209 230.286 110.471 230.082 98.2684 229.149ZM204.634 142.971C196.397 117.532 192.063 90.8821 192.063 64.0381C192.063 28.6699 163.383 0 128.006 0C92.6304 0 63.9508 28.6699 63.9508 64.0381C63.9508 91.1077 59.6771 117.608 51.4294 142.988C70.6824 148.399 96.7532 152.262 128.006 152.262C159.277 152.261 185.365 148.391 204.634 142.971ZM221.76 183.792C217.551 175.798 213.859 167.56 210.517 159.195C186.963 165.984 157.435 169.495 128.006 169.495C98.5791 169.495 69.0683 165.995 45.5227 159.204C42.1746 167.534 38.4798 175.756 34.2549 183.783C32.7157 186.705 31.7969 188.531 31.7969 188.707C31.7969 202.147 74.8745 213.051 128.006 213.051C181.139 213.051 224.207 202.146 224.207 188.707C224.208 188.53 223.291 186.704 221.76 183.792Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.82fcc415446d7237366ed8eed42e5815.svg";
export { ForwardRef as ReactComponent };